import React from "react";
import { TIPOS_PERSONAL, TIPOS_CONTRATACION, ESTADOS_EMPLEADO } from "../constants/rrhh";
import { soloDigitosCedula } from "../../../../utils/documentoIdentidad";

const soloDigitosTelefono = (value) => String(value || "").replace(/\D/g, "").slice(0, 10);

function Modal({ open, title, onClose, size = "modal-lg", children }) {
  if (!open) return null;
  return (
    <div
      className="modal fade show d-block management-modal"
      tabIndex="-1"
      style={{ backgroundColor: "rgba(15, 23, 42, 0.45)" }}
      aria-modal="true"
      role="dialog"
    >
      <div className={`modal-dialog ${size} modal-dialog-centered`} role="document">
        <div className="modal-content">
          <div className="modal-header border-0">
            <h5 className="modal-title">{title}</h5>
            <button type="button" className="btn-close" aria-label="Cerrar" onClick={onClose} />
          </div>
          {children}
        </div>
      </div>
    </div>
  );
}

function EmpleadoForm({ form, setForm, onSubmit, onClose, puestos = [], isEdit = false, saving }) {
  const esServiciosOHibrido = form.tipoContratacion === "servicios" || form.tipoContratacion === "hibrido";

  return (
    <form onSubmit={(e) => { e.preventDefault(); onSubmit?.(); }}>
      <div className="modal-body pt-0">
        <div className="row g-3">

          {/* Datos personales */}
          <div className="col-12">
            <p className="management-label mb-2">Datos personales</p>
          </div>
          <div className="col-md-6">
            <label className="form-label management-label">Nombres *</label>
            <input
              className="form-control"
              value={form.nombres}
              onChange={(e) => setForm((prev) => ({ ...prev, nombres: e.target.value.toUpperCase() }))}
              required
            />
          </div>
          <div className="col-md-6">
            <label className="form-label management-label">Apellidos *</label>
            <input
              className="form-control"
              value={form.apellidos}
              onChange={(e) => setForm((prev) => ({ ...prev, apellidos: e.target.value.toUpperCase() }))}
              required
            />
          </div>
          <div className="col-md-4">
            <label className="form-label management-label">Cédula *</label>
            <input
              className="form-control"
              inputMode="numeric"
              maxLength={10}
              value={form.cedula}
              onChange={(e) => setForm((prev) => ({ ...prev, cedula: soloDigitosCedula(e.target.value) }))}
              required
            />
          </div>
          <div className="col-md-4">
            <label className="form-label management-label">Teléfono</label>
            <input
              className="form-control"
              inputMode="numeric"
              maxLength={10}
              value={form.telefono}
              onChange={(e) => setForm((prev) => ({ ...prev, telefono: soloDigitosTelefono(e.target.value) }))}
              placeholder="09xxxxxxxx"
            />
          </div>
          <div className="col-md-4">
            <label className="form-label management-label">Email</label>
            <input
              type="email"
              className="form-control"
              value={form.email}
              onChange={(e) => setForm((prev) => ({ ...prev, email: e.target.value.toLowerCase() }))}
              placeholder="correo@dominio.com"
            />
          </div>

          {/* Datos laborales */}
          <div className="col-12 mt-2">
            <p className="management-label mb-2">Datos laborales</p>
          </div>
          <div className="col-md-4">
            <label className="form-label management-label">Tipo personal *</label>
            <select
              className="form-select"
              value={form.tipoPersonal}
              onChange={(e) => setForm((prev) => ({ ...prev, tipoPersonal: e.target.value }))}
              required
            >
              {TIPOS_PERSONAL.map((t) => (
                <option key={t.value} value={t.value}>{t.label}</option>
              ))}
            </select>
          </div>
          <div className="col-md-4">
            <label className="form-label management-label">Tipo contratación *</label>
            <select
              className="form-select"
              value={form.tipoContratacion}
              onChange={(e) => setForm((prev) => ({ ...prev, tipoContratacion: e.target.value }))}
              required
            >
              {TIPOS_CONTRATACION.map((t) => (
                <option key={t.value} value={t.value}>{t.label}</option>
              ))}
            </select>
          </div>
          <div className="col-md-4">
            <label className="form-label management-label">Puesto</label>
            <select
              className="form-select"
              value={form.puestoId}
              onChange={(e) => setForm((prev) => ({ ...prev, puestoId: e.target.value }))}
            >
              <option value="">Sin puesto asignado</option>
              {puestos.map((p) => (
                <option key={p.id} value={String(p.id)}>{p.nombre}</option>
              ))}
            </select>
          </div>
          <div className="col-md-4">
            <label className="form-label management-label">Fecha de ingreso</label>
            <input
              type="date"
              className="form-control"
              value={form.fechaIngreso}
              onChange={(e) => setForm((prev) => ({ ...prev, fechaIngreso: e.target.value }))}
            />
          </div>
          <div className="col-md-4">
            <label className="form-label management-label">Sueldo base</label>
            <div className="input-group">
              <span className="input-group-text">$</span>
              <input
                type="number"
                min="0"
                step="0.01"
                className="form-control"
                value={form.sueldoBase}
                onChange={(e) => setForm((prev) => ({ ...prev, sueldoBase: e.target.value }))}
                placeholder="0.00"
              />
            </div>
          </div>
          {isEdit && (
            <div className="col-md-4">
              <label className="form-label management-label">Estado</label>
              <select
                className="form-select"
                value={form.estado}
                onChange={(e) => setForm((prev) => ({ ...prev, estado: e.target.value }))}
              >
                {ESTADOS_EMPLEADO.map((e) => (
                  <option key={e.value} value={e.value}>{e.label}</option>
                ))}
              </select>
            </div>
          )}

          {/* RUC (solo para servicios o híbrido) */}
          {esServiciosOHibrido && (
            <>
              <div className="col-12 mt-2">
                <p className="management-label mb-0">Datos de facturación</p>
                <small className="text-muted">Requerido porque el empleado factura por servicios prestados.</small>
              </div>
              <div className="col-md-6">
                <label className="form-label management-label">RUC</label>
                <input
                  className="form-control"
                  value={form.ruc}
                  onChange={(e) => setForm((prev) => ({ ...prev, ruc: e.target.value.toUpperCase() }))}
                  placeholder="1234567890001"
                />
              </div>
            </>
          )}

          {/* Observaciones */}
          <div className="col-12">
            <label className="form-label management-label">Observaciones</label>
            <textarea
              className="form-control"
              rows={2}
              value={form.observaciones}
              onChange={(e) => setForm((prev) => ({ ...prev, observaciones: e.target.value.toUpperCase() }))}
            />
          </div>
        </div>
      </div>
      <div className="modal-footer border-0 pt-0">
        <button type="button" className="btn btn-outline-secondary" onClick={onClose}>Cancelar</button>
        <button type="submit" className="btn management-btn-primary" disabled={saving}>
          {saving ? "Guardando..." : isEdit ? "Actualizar" : "Registrar"}
        </button>
      </div>
    </form>
  );
}

export default function EmpleadoFormModal({
  modal, puestos,
  formNuevo, setFormNuevo,
  formEditar, setFormEditar,
  saving, deleting,
  cerrarModal,
  handleCrear, handleActualizar, handleEliminar,
  empleadoEditando,
}) {
  return (
    <>
      <Modal open={modal === "crear"} title="Nuevo empleado" onClose={cerrarModal} size="modal-xl">
        <EmpleadoForm form={formNuevo} setForm={setFormNuevo} onSubmit={handleCrear} onClose={cerrarModal} puestos={puestos} saving={saving} />
      </Modal>

      <Modal open={modal === "editar"} title="Editar empleado" onClose={cerrarModal} size="modal-xl">
        <EmpleadoForm form={formEditar} setForm={setFormEditar} onSubmit={handleActualizar} onClose={cerrarModal} puestos={puestos} isEdit saving={saving} />
      </Modal>

      <Modal open={modal === "eliminar"} title="Dar de baja al empleado" onClose={cerrarModal} size="modal-md">
        <div className="modal-body pt-0">
          <p>¿Confirmas dar de baja a <strong>{empleadoEditando?.apellidos}, {empleadoEditando?.nombres}</strong>?</p>
          <p className="text-muted mb-0">El registro quedará inactivo pero no se eliminará.</p>
        </div>
        <div className="modal-footer border-0 pt-0">
          <button type="button" className="btn btn-outline-secondary" onClick={cerrarModal}>Cancelar</button>
          <button type="button" className="btn btn-danger" onClick={handleEliminar} disabled={deleting}>
            {deleting ? "Procesando..." : "Dar de baja"}
          </button>
        </div>
      </Modal>
    </>
  );
}
